export enum EnumTypeTables {
    statistics = 'Estatísticas',
    operators = 'Operadores',
    suppliers = 'Fornecedores',
    staff = 'Staff'
}